<template>
  <div class="zuhu">
    <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" v-if="zuhu.queryFrom">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model.trim="filters.name" placeholder="请输入租户姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="queryFrom()" v-if="zuhu.queryFrom">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="clearForm()" v-if="zuhu.queryFrom">重置</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <el-card  class="box-card">
      <div slot="header" class="clearfix header" style="font-size: 16px;">
        <span class="card-header">租户信息</span>
        <el-button class="fr" size="mini" type="success" @click="handleAdd()" v-if="zuhu.handleAdd">新增</el-button>
      </div>
      <!--新增界面-->
      <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close='emptyDialog'>
        <el-form :label-position="labelPosition" :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
          <el-row>
            <el-form-item label="租户名称:" prop="deptName" style="width: 40%;" class="fl">
              <el-input v-model.trim="editForm.deptName"></el-input>
            </el-form-item>
            <el-form-item label="访问路径:" prop="loginUrl" style="width: 55%;" class="fr">
              <el-input v-model.trim="editForm.loginUrl" placeholder="请输入字母或者数字"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="租户编码:" prop="deptCode" style="width: 40%;" class="fl">
              <el-input type="text" v-model.trim="editForm.deptCode"></el-input>
            </el-form-item>
            <el-form-item label="租户地址:" prop="deptAddr" style="width: 55%;" class="fr">
              <el-input type="text" v-model.trim="editForm.deptAddr"></el-input>
            </el-form-item>    
          </el-row>
          <el-row>
            <el-form-item label="联系人:" prop="deptLinkman" style="width: 40%;" class="fl">
              <el-input type="text" v-model.trim="editForm.deptLinkman"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" prop="deptLinkmanPhone" style="width: 55%;" class="fr">
              <el-input type="text" v-model.trim="editForm.deptLinkmanPhone"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
          <el-form-item label="电子邮箱:" prop="deptLinkmanEmail" style="width: 40%;" class="fl">
            <el-input type="text" v-model.trim="editForm.deptLinkmanEmail"></el-input>
          </el-form-item>
          <el-form-item label="是否启用:" style="width: 55%;" class="fr">
            <el-switch 
            v-model="formIsValid" 
            :active-value="1" 
            :inactive-value="-1" 
            @change='changeSwitch()'>
            </el-switch>
          </el-form-item>
        </el-row>
          <el-form-item label="备注:" prop="memo">
            <el-input type="textarea" v-model.trim="editForm.memo"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">添加</el-button>
          <el-button v-else type="primary" @click="updateDataType">保存</el-button>
          <el-button @click="emptyDialog()">取消</el-button>
        </div>
      </el-dialog>
      <!--列表-->
      <el-table :data="users" highlight-current-row border style="width: 100%;" 
      :header-cell-style= "{'text-align':'center'}">
        <el-table-column prop="dept.deptName" label="租户姓名" width="150" align="center" >
          <template slot-scope="scope" v-for="(item,index) in users" :keys="index">
           <span v-if="scope.row.dept !== null">{{scope.row.dept.deptName}}</span>
           <span v-else>暂无</span>
          </template>
        </el-table-column>
        <el-table-column prop="loginUrl" label="访问路径" width="150" sortable align="center">
        </el-table-column>
        <el-table-column prop="hasRole" label="是否授权" width="150" align="center">
          <template  slot-scope="scope" v-for="(item,index) in users" :keys="index">
            <span v-if="scope.row.hasRole == '0'">否</span>
            <span v-if="scope.row.hasRole == '1'">是</span>
          </template>
        </el-table-column>
        <el-table-column prop="user.loginName" label="管理员账号" width="150" align="center">
          <template slot-scope="scope" v-for="(item,index) in users" :keys="index">
           <span v-if="scope.row.user.loginName !== ''">{{scope.row.user.loginName}}</span>
           <span v-else>暂无</span>
          </template>
        </el-table-column>
        <el-table-column prop="isValid" label="是否启用" width="150" align="center">
          <template  slot-scope="scope" v-for="(item,index) in users" :keys="index">
            <span v-if="scope.row.isValid == '1'">启用</span>
            <span v-if="scope.row.isValid == '-1'">停用</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="150" align="center">
          <template slot-scope="scope">
            <el-dropdown  trigger="click">
              <el-button type="primary">
                更多操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleEdit(scope.$index, scope.row)" v-if="zuhu.changezuhu">修改租户</el-dropdown-item>
                <el-dropdown-item v-if='scope.row.hasRole == "1" && zuhu.changeAllow' @click.native="changeAllow(scope.$index, scope.row)">修改授权</el-dropdown-item>
                <el-dropdown-item v-else @click.native="createAllow(scope.$index, scope.row)">租户授权</el-dropdown-item>
                <el-dropdown-item v-if='scope.row.hasRole == "1" && scope.row.user.loginName == "" && zuhu.createAdmin' @click.native="createAdmin(scope.$index, scope.row)">创建管理员</el-dropdown-item>
                <el-dropdown-item v-if='scope.row.user.loginName !== "" && zuhu.changePassWord' @click.native="changePassWord(scope.$index, scope.row)">重置密码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-col :span="24" class="toolbar">
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="pages.total">
          </el-pagination>
        </div>
      </el-col>
    </el-card>
    <!-- 租户授权界面 -->
    <el-dialog :title="textMenu[dialogStatus]" :visible.sync="dialogTableVisible" @close='emptyDialog2'>
      <el-form :label-position="labelPosition" :model="allowForm" label-width="100px" 
      :rules="allowFormRules" ref="allowForm">
        <el-form-item label="角色名称:" prop="roleName" v-if="dialogStatus =='create'">
          <el-input v-model.trim="allowForm.roleName"></el-input>
        </el-form-item>
        <el-form-item label="角色名称:" prop="roleName" v-if="dialogStatus =='update'">
          <el-input v-model.trim="allowForm.roleName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="memo">
          <el-input type="textarea" v-model.trim="allowForm.memo"></el-input>
        </el-form-item>
      </el-form>
      <p style="margin:20px 0;">功能权限：</p>
      <ul class="role-table row">
        <li class="header2">
          <div class="left" style="width: 30%;text-align: center;">模块名称</div>
          <div class="right" style="width: 70%;text-align: center;">权限名称</div>
        </li>
        <li v-for="(item,index) in testLists" :key="index">
          <div class="left h40" style="width: 30%;text-align: center;">{{item.menuName}}</div>
          <div class="right h40" style="width: 70%;text-align: center;">
            <el-checkbox-group v-model="checkList" >
              <el-checkbox v-for="(m,index) in item.children" :label="m.autId" :key="m.id"> 
                {{m.autName}}
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="line"></div>
        </li>
      </ul>
      <div style="width: 30%;margin: 20px auto;" class="clearfix">
        <el-button v-if="dialogStatus =='update'" class="fl" type="success" @click="saveRoleAuth('allowForm')" style="display: block;">保存</el-button>
        <el-button v-else class="fl" type="success" @click="createRoleAuth('allowForm')" style="display: block;">添加</el-button>
        <el-button class="fr" type="warning" @click.native="dialogTableVisible=false" style="display: block;">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="创建账号" :visible.sync="dialogcreateAdmin" >
      <el-form :label-position="labelPosition" :model="createAdminForm" label-width="100px" 
      :rules="createAdminFormRules" ref="createAdminForm">
        <el-form-item label="登录名:" prop="loginName"><span>{{createAdminForm.loginUrl}}_</span>
          <el-input v-model.trim="createAdminForm.loginName"></el-input>
        </el-form-item>
        <el-form-item label="密码:" prop="password">
          <el-input v-model.trim="createAdminForm.password" type="password"></el-input><br>
          <span style="color:red;">(默认密码为"New@0987")</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createAdminData()">确定</el-button>
        <el-button @click.native="dialogcreateAdmin=false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 重置密码界面 -->
    <el-dialog title="信息提示:" :visible.sync="dialogPassWordVisible" >
      <p>确认重置租户'{{passwordForm.dept.deptName}}'的密码？（重置后的密码为'{{passwordForm.password}}'）</p>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateData">确定</el-button>
        <el-button @click.native="dialogPassWordVisible=false">取消</el-button>
        <!-- <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button> -->
      </div>
    </el-dialog>
  </section>
  </div>
	
</template>

<script>
  import {
    selectInfos,addinfos,edit,updateDdit,showEdit,inseRole,updateauthorization,insetuser,resetPassword
  } from "../../api/api";
  import {checkStrong} from '../../components/checkpassStrong.js'
  import {getPermission} from '../../api/authRequest'

  export default {
    name: 'zuhu',
    data() {
      var validateRoleName = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入角色名称'))
          } else {
            callback()
          }
        }
      const validatePhone = (rule, value, callback) => {
          if (value === '') {
            callback()
          } else {
            if (!(/^1[345789]\d{9}$/.test(value))) {
              callback(new Error('请输入正确的11位手机号'))
            }
            callback()
          }
        }
        const validateEmail = (rule, value, callback) => {
          if (value === '') {
            callback()
          } else {
            if (!(/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/.test(value))) {
              callback(new Error('请输入正确的邮箱地址'))
            }
            callback()
          }
        }
      return {
        zuhu:{
          queryFrom:false,
          handleAdd:false,
          changezuhu:false,
          changeAllow:false,
          createAllow:false,
          changePassWord:false,
          createAdmin:false,
        },
        checkAll:[],
        formIsValid:1,
        dialogStatus:'',
        textMenu: {
          create:'租户授权',
          update: "修改授权",
        },
        checkList: [],
        testLists: [],
        menuList:[],
        allAuthorityList:[],
        roleAuthorityList:[],
        wacthList:'',
        filters: {
          name: ""
        },
        //分页变量
        pages:{
          total: 0,
          page: 1,
          pageSize: 10,
        },
        users: [
          {
            dept: {
              deptName:''
            },
            loginUrl: '',
            hasRole: '',
            user: {
              loginName: ''
            },
            isValid: '是',
            passWord:'New@0987'
          }
        ],
        dialogPassWordVisible: false,
        dialogTableVisible: false,
        dialogStatus: "",
        textMap: {
          update: "修改信息",
          create: "新增信息"
        },
        dialogFormVisible: false,
        dialogFormEditVisible: false,
        passwordForm: {
          dept:{
            deptName:'',
          },
          password:''
        },
        allowForm: {
          roleName: '',
          memo: '',
        },
        allowFormRules: {
          roleName: [{ required: true, message: "请输入角色名称", trigger: "submit" }],
        },
        editFormRules: {//validateRoleName
          deptName: [{ required: true, message: "请输入姓名", trigger: "submit" }],
          loginUrl: [{ required: true, message: "请输入访问路径", trigger: "submit" }],
          deptLinkmanPhone: [
              { validator: validatePhone, trigger: 'submit' }
            ],
          deptLinkmanEmail: [
              { validator: validateEmail, trigger: 'submit' }
            ]
        },
        //新增界面数据
        editForm: {
          id: '',
          deptId: '',
          deptName: '',
          loginUrl: '',
          deptCode: '',
          deptAddr: '',
          deptLinkman: '',
          deptLinkmanPhone: '',
          deptLinkmanEmail: '',
          memo:'',
          isValid: 1,
        },
        labelPosition: 'left',
        addFormVisible: false, //新增界面是否显示
        addFormRules: {
          deptName: [{ required: true, message: "请输入姓名", trigger: "blur" }]
        },
        dialogcreateAdmin:false,
        createAdminForm:{
          loginName: 'superAdmin',
          password: 'New@0987',
          loginUrl: '',
          checkstrong: '弱'
        },
        createAdminFormRules: {
          loginName: [{ required: true, message: "请输入登录名", trigger: "blur" }]
        },

      }
    },
    mounted() {
      this.zuhu.queryFrom= getPermission('/system/lessee/selectinfos');
      this.zuhu.handleAdd= getPermission('/system/lessee/addinfos');
      this.zuhu.changezuhu= getPermission('/system/lessee/updateDdit');
      this.zuhu.changeAllow= getPermission('/system/lessee/updateauthorization');
      this.zuhu.createAllow= getPermission('/system/lessee/inseRole');
      this.zuhu.changePassWord= getPermission('/system/lessee/resetPassword');
      this.zuhu.createAdmin= getPermission('/system/lessee/insetuser');
      this.getUsers()
    },
    methods: {
      changeSwitch() {
        console.log(this.formIsValid)
        this.editForm.isValid = this.formIsValid
      },
      //获取租户信息
      getUsers() {
        let para = {
          deptName: this.filters.name,
          startRow: this.pages.page,
          pageSize: this.pages.pageSize
        };
        selectInfos(para).then(res => {
          // console.log(res.data.status)
          if (res.data.status == 100) {
            this.users = res.data.results.list
            this.pages.pageSize = res.data.results.pageSize
            this.pages.page = res.data.results.pageNum
            this.pages.total = res.data.results.total
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //查询重置
      clearForm:function() {
        this.filters.name = ''
      },
      //清空dialog
      emptyDialog:function() {
        this.editForm = {}
        this.dialogFormVisible = false
      },
      //清空dialog
      emptyDialog2:function() {
        this.allowForm = {}
        this.checkList = []
        this.dialogTableVisible = false
      },
      //查询
      queryFrom:function() {
        console.log(this.filters.name)
        this.getUsers()
      },
      handleSizeChange(val) {
        this.pages.pageSize = val
        this.getUsers()
      },
      handleCurrentChange(Page) {
        this.pages.page = Page
        this.getUsers()
      },
      //点击显示新增界面
      handleAdd: function() {
        this.dialogStatus = "create";
        this.dialogFormVisible = true;
        // console.log(this.editForm)
      },
      //确认新增内容，并发送内容到对应的接口
      createData: function() {
        // console.log(this.editForm)
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {})
              .then(() => {
                // console.log(this.editForm)
                let para = Object.assign({}, this.editForm);
                // console.log(para)
                addinfos(para).then(res => {
                  this.$message({
                    message: "提交成功",
                    type: "success"
                  });
                  this.$refs.editForm.resetFields();
                  this.dialogFormVisible = false;
                   //获取用户列表
                  this.getUsers();
                });
              })
            .catch(e => {
              // 打印一下错误
              console.log(e);
            });
          }
        });
      },
      //显示编辑界面
      handleEdit: function(index, row) {
        this.dialogStatus = "update";
        this.dialogFormVisible = true;
        this.editForm = Object.assign({}, row);
        console.log(this.editForm)
        let para={
          id:this.editForm.id
        }
        edit(para).then(res => {
          if (res.data.status ==100) {
            this.editForm = res.data.results.dept
            this.editForm.loginUrl = res.data.results.loginUrl
            this.editForm.id = res.data.results.id
            this.formIsValid = res.data.results.isValid
          }
        }).catch((error) =>{ 
          this.$Message.error(error.message);
        })
      },
      //确认修改
      updateDataType:function() {
        console.log(this.editForm)
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {})
              .then(() => {
                // let para = Object.assign({}, this.editForm);
                let para = {
                  id: this.editForm.id,
                  deptId: this.editForm.deptId,
                  deptName: this.editForm.deptName,
                  loginUrl: this.editForm.loginUrl,
                  deptCode: this.editForm.deptCode,
                  deptAddr: this.editForm.deptAddr,
                  deptLinkman: this.editForm.deptLinkman,
                  deptLinkmanPhone: this.editForm.deptLinkmanPhone,
                  deptLinkmanEmail: this.editForm.deptLinkmanEmail,
                  memo: this.editForm.memo,
                  isValid:this.formIsValid
                }

                updateDdit(para).then(res => {
                  // console.log(this.editForm)
                  // console.log(res.data.status == 100)
                  if (res.data.status == 100) {
                    this.$message({
                      message: res.data.message,
                      type: "success"
                    });
                    this.$refs["editForm"].resetFields();
                    this.dialogFormVisible = false;
                    this.getUsers();
                  }else{
                    this.$message({
                      message: res.data.message,
                      type: "error"
                    });
                  }
                });
              })
              .catch(e => {
                // 打印一下错误
                console.log(e);
              });
          }
        });
      },
      //显示租户授权界面
      createAllow: function(index, row) {
        this.dialogTableVisible = true;
        this.dialogStatus = "create";
        this.wacthList = Object.assign({}, row);
        // console.log(this.wacthList)
        let para={
          deptId:row.dept.deptId
        }
        showEdit(para).then(res => {
          if (res.data.status ==100) {
            this.allAuthorityList = res.data.results.authList
            // this.checkList = res.data.results.chooseAuthority

            var map = {},
                dest = [];
            for(var i = 0; i < this.allAuthorityList.length; i++){
                var ai = this.allAuthorityList[i];
                if(!map[ai.menuId]){
                    dest.push({
                        menuId: ai.menuId,
                        menuName: ai.menuName,
                        children: [ai]
                    });
                    map[ai.menuId] = ai;
                }else{
                    for(var j = 0; j < dest.length; j++){
                        var dj = dest[j];
                        if(dj.menuId == ai.menuId){
                            dj.children.push(ai);
                            break;
                        }
                    }
                }
            }
            this.testLists = dest
            // console.log(this.testLists);
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //确认授权
      createRoleAuth(formName) {
        // console.log(this.checkList.length)
         // console.log(this.allowForm)
         if (this.checkList.length == 0) {
          this.$message({
            message: '请为租户至少选择一项功能权限',
            type: "success"
          });
         }else{
          this.$refs[formName].validate((valid) => {
          if (valid) {
            // console.log(this.wacthList)
            let para = {
              // roleId: this.allowForm.roleId,
              roleName: this.allowForm.roleName,
              memo: this.allowForm.memo,
              belongDeptId:this.wacthList.belongOrgId,
              belongLesseeId:this.wacthList.id,
              arrID:this.checkList.toString()
            }
            // console.log(para)
            inseRole(para).then((res) => {
              if (res.data.status == 100) {
                // console.log(res.data.results)
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                this.$refs.allowForm.resetFields();
                this.dialogTableVisible = false;
                this.getUsers();
              }else{
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            }).catch((error) => {
                this.$Message.error(error.message);
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
         }
        
      },
      //显示修改授权界面
      changeAllow: function(index, row) {
        this.dialogTableVisible = true;
        this.dialogStatus = "update";
        this.wacthList = Object.assign({}, row);
        // console.log(row.dept.deptId)
        let para={
          belongDeptId:row.dept.deptId
        }
        showEdit(para).then(res => {
          if (res.data.status == 100) {
            // console.log(res.data.results)
            this.allowForm = res.data.results.role
            // console.log(this.allowForm)
            this.allAuthorityList = res.data.results.authList
            this.checkList = res.data.results.chooseAuthority

            var map = {},
                dest = [];
            for(var i = 0; i < this.allAuthorityList.length; i++){
                var ai = this.allAuthorityList[i];
                if(!map[ai.menuId]){
                    dest.push({
                        menuId: ai.menuId,
                        menuName: ai.menuName,
                        children: [ai]
                    });
                    map[ai.menuId] = ai;
                }else{
                    for(var j = 0; j < dest.length; j++){
                        var dj = dest[j];
                        if(dj.menuId == ai.menuId){
                            dj.children.push(ai);
                            break;
                        }
                    }
                }
            }
            // console.log(this.testLists);
            this.testLists = dest
            // console.log(this.testLists);
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
        
      },
      //确认修改授权
      saveRoleAuth(formName) {
        var arrIdNew = JSON.stringify(this.checkList)
        // console.log(this.checkList.toString())
        // console.log(this.allowForm)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // console.log(this.allowForm)
            let para = {
              roleId: this.allowForm.roleId,
              roleName: this.allowForm.roleName,
              memo: this.allowForm.memo,
              belongLesseeId:this.wacthList.id,
              arrID:this.checkList.toString()
            }
            updateauthorization(para).then((res) => {
              if (res.data.status == 100) {
                // console.log(res.data.results)
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                this.dialogTableVisible = false;
                this.getUsers();
              }
            }).catch((error) => {
                this.$Message.error(error.message);
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        
      },
      //确认修改授权
      saveRoleAuth(formName) {
        var arrIdNew = JSON.stringify(this.checkList)
        console.log(this.checkList.toString())
        console.log(this.allowForm)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log(this.allowForm)
            let para = {
              roleId: this.allowForm.roleId,
              roleName: this.allowForm.roleName,
              memo: this.allowForm.memo,
              belongLesseeId:this.wacthList.id,
              arrID:this.checkList.toString()
            }
            updateauthorization(para).then((res) => {
              if (res.data.status == 100) {
                // console.log(res.data.results)
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                this.dialogTableVisible = false;
                this.getUsers();
              }
            }).catch((error) => {
                this.$Message.error(error.message);
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        
      },
      //显示创建管理员界面
      createAdmin: function(index,row) {
        this.dialogcreateAdmin = true;
        this.createAdminForm = Object.assign({}, row);
        console.log(this.createAdminForm)
        this.createAdminForm.loginName = 'superAdmin'
        this.createAdminForm.password = 'New@0987'
      },
      //insetuser 确认创建
      createAdminData() {
        // alert(1111)
        console.log(this.createAdminForm)
        let para = {
          loginUrl: this.createAdminForm.loginUrl,
          loginName: this.createAdminForm.loginName,
          password: this.createAdminForm.password,
          deptId:this.createAdminForm.dept.deptId,
          belongLesseeId:this.createAdminForm.id
        }
        console.log(para)
        insetuser(para).then((res) => {
          if (res.data.status ==100) {
            // console.log(111111)
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.dialogcreateAdmin = false;
            this.getUsers();
          }
        }).catch((error) => {
            this.$Message.error(error.message);
        })
      },
      //显示重置密码界面 
      changePassWord: function(index, row) {
        this.dialogPassWordVisible = true;
        this.passwordForm = Object.assign({}, row);
        // console.log(this.passwordForm)
        this.passwordForm.password = 'jihouhou123'
      },
      updateData:function() {
        console.log(this.passwordForm.dept.deptId)
        const deptId = this.passwordForm.dept.deptId
        const deptData = {deptId:deptId}
        resetPassword(deptData).then((res) => {
          // console.log(res)
          if (res.data.status ==100) {
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.dialogPassWordVisible = false;
            this.getUsers();
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
      },
    },
    watch: {
      'createAdminForm.password'(newValue,oldValue){
        console(newValue)
        this.createAdminForm.checkstrong = checkStrong(newValue)
      }
    },
  };
</script>

<style lang="scss" scoped>
 .zuhu{font-size: 14px;
    .box-card{margin-bottom: 15px;border-radius: 0px;
      /*.header{background-color: #f5f5f5}*/
      .card-header{line-height: 0px;}
    }
    .role-table {
      border: 1px solid #e0e0e0;
      border-bottom: none;
      padding: 0;
      position: relative;
    }
    .header2 {
    height: 35px;
    line-height: 35px;
    border-bottom: 1px solid #e7e7e7;
    background: #F8F8F9;
    text-align: center;
    }
    .vertical-line {
        width: 1px;
        height: 100%;
        background: #ddd;
        position: absolute;
        left: 30%;
        top: 0
    }

    .left {
        width: 30%;
        float: left;
        padding-left: 10px;
        user-select: none;
        cursor: pointer;
    }
    .one {
        padding-left: 20px;
    }
    .right {
        width: 60%;
        float: left;
        padding-left: 10px;
        border-left: 1px solid #ddd;
    }
    .item-icon {
        margin-left: -5px;
        padding: 5px;
    }
    .line {
        clear: both;
        width: 100%;
        height: 1px;
        background: #e0e0e0;
    }
    .h40{
        /*height: 39px;*/
        line-height: 39px;
    }
    [v-cloak] {
        display: none;
    }
    .toolbar{margin: 20px 0;}
    .el-form-item__label{float: left;}
    .el-checkbox{width: 25%;float: left;text-align: left;}
    .is-checked{margin: 0px;text-align: left;}
    .el-checkbox+.el-checkbox {
    margin-left: 0px;text-align: left;
    }
    .isActive{width: 50px;height: 26px;background-color: #c41335;border-radius: 3px;line-height: 26px;text-align: center;color: #fff;margin-top: 6px;}
    @keyframes goWidth
    {
    from {width: 50px;}
    to {width: 100px;}
    }

    @-moz-keyframes goWidth /* Firefox */
    {
    from {width: 50px;}
    to {width: 100px;}
    }

    @-webkit-keyframes goWidth /* Safari 和 Chrome */
    {
    from {width: 50px;}
    to {width: 100px;}
    }

    @-o-keyframes goWidth /* Opera */
    {
    from {width: 50px;}
    to {width: 100px;}
    }
    .isActive1{
      background-color: #fb9b03;
      animation: goWidth 1s;
      -moz-animation: goWidth 1s;  /* Firefox */
      -webkit-animation: goWidth 1s;  /* Safari 和 Chrome */
      -o-animation: goWidth 1s; /* Opera */
      width: 100px;}
    @keyframes goWidth2
    {
    from {width: 100px;}
    to {width: 150px;}
    }

    @-moz-keyframes goWidth2 /* Firefox */
    {
    from {width: 100px;}
    to {width: 150px;}
    }

    @-webkit-keyframes goWidth2 /* Safari 和 Chrome */
    {
    from {width: 100px;}
    to {width: 150px;}
    }

    @-o-keyframes goWidth2 /* Opera */
    {
    from {width: 100px;}
    to {width: 150px;}
    }
    .isActive2{background-color: #1a9203;
      animation: goWidth2 1s;
      -moz-animation: goWidth2 1s;  /* Firefox */
      -webkit-animation: goWidth2 1s;  /* Safari 和 Chrome */
      -o-animation: goWidth2 1s; /* Opera */
      width:150px;
    }
  }
</style>


// WEBPACK FOOTER //
// zuhu.vue?d4b8718c